import { render, staticRenderFns } from "./AttachmentItem.vue?vue&type=template&id=18787e6a&scoped=true"
import script from "./AttachmentItem.vue?vue&type=script&lang=js"
export * from "./AttachmentItem.vue?vue&type=script&lang=js"
import style0 from "./AttachmentItem.vue?vue&type=style&index=0&id=18787e6a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18787e6a",
  null
  
)

export default component.exports